import { Button, Hint, Input } from "@ui";
import style from "./GenerateToken.module.scss";
import { useGenerateTokenMutation, useGetUserQuery } from "@RTKQuery/user/auth/auth";
import cn from "classnames";

export function GenerateToken() {
    const { data } = useGetUserQuery()

    const [generateToken, generateTokenStatus] = useGenerateTokenMutation();

    return (
        <div className={style.container}>
            {
                data?.api_token
                    ? <div>
                        <div className="flex mb-[10px] gap-[10px] items-center">
                            <Input
                                value={data.api_token}
                                readOnly
                                actions="copy"
                                customStyle={{
                                    width: "!w-full !max-w-full"
                                }}
                            />
                            <Hint
                                align="right"
                                targetElement={
                                    <Button
                                        color="orange"
                                        form="ellipse"
                                        icon={<UpdateIcon className={cn("flex-shrink-0", generateTokenStatus.isLoading && "animate-spin")} />}
                                        customStyle={{
                                            button: "!h-full !p-[10px]",
                                            icon: "!w-[20px]"
                                        }}
                                        errors={[
                                            (generateTokenStatus.error && ((extractError) => {
                                                return extractError(generateTokenStatus.error)
                                            }))
                                        ]}
                                        onClick={() => {
                                            generateToken()
                                        }}
                                        resetStatus={() => {
                                            generateTokenStatus.reset();
                                        }}
                                    />
                                }
                                hintText={<p className="text-[14px]">Згенерувати новий токен</p>}
                            />
                        </div>
                        <a className="text-[#2e73b4] font-medium" href="https://api.rocket-proxy.io/redoc" target="_blank" rel="noopener noreferrer">Документація API</a>
                    </div>
                    : <Button
                        text="Згенерувати токен"
                        customStyle={{
                            width: "!w-full !max-w-full",
                            button: "!w-full !h-[40px] !max-w-full",
                            text: "!text-[17px]"
                        }}
                        form="rectangle"
                        color="blue"
                        onClick={() => {
                            generateToken()
                        }}
                        loading={generateTokenStatus.isLoading}
                        errors={[
                            (generateTokenStatus.error && ((extractError) => {
                                return extractError(generateTokenStatus.error)
                            }))
                        ]}
                        resetStatus={() => {
                            generateTokenStatus.reset();
                        }}
                    />
            }
        </div>
    )
}

function UpdateIcon({ className }: { className: string }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 11 12" fill="none">
            <g clipPath="url(#clip0_2339_22559)">
                <path d="M9.16138 3.46775L8.75956 3.05646C6.98447 1.23926 4.10646 1.23926 2.33134 3.05646C0.556219 4.87365 0.556219 7.81992 2.33134 9.63711C4.10646 11.4543 6.98447 11.4543 8.75956 9.63711C9.79184 8.58038 10.2238 7.14174 10.0556 5.76546M9.16138 3.46775H6.75074M9.16138 3.46775V1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2339_22559">
                    <rect width="11" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}